import { onDemandQualityOptions } from '@/configuration'

type QualityOption = { needsSub: boolean }

const OPTIONS = onDemandQualityOptions as Record<string, QualityOption>

const DEFAULT_QUALITY_KEY = 'low'

// The listener's saved key is their CHOICE and is never rewritten for entitlement.
// A Premium-only choice is held back only once we KNOW they are not Premium — an
// unanswered or failed check holds nothing back (the API and the stream servers
// refuse Premium playback to non-Subscriber accounts themselves) —
// so the choice comes back on its own when they renew.
export function effectiveQualityKey(chosenKey: string | null | undefined, isKnownNotPremium: boolean): string {
    if (!chosenKey || !Object.hasOwn(OPTIONS, chosenKey)) return DEFAULT_QUALITY_KEY
    if (OPTIONS[chosenKey].needsSub && isKnownNotPremium) return DEFAULT_QUALITY_KEY
    return chosenKey
}
